import React, { useState, useEffect } from "react";
import { SEO } from "../components/seo";
import { Link, navigate } from "gatsby";
import { imageUrl } from "../actions/miscAction";
import Footer from "../components/common/footer";
import DateFormat from "../components/common/dateFormat";
import Skeleton from "react-loading-skeleton";
import _ from "lodash";
import Header from "../components/newDesign/header/header";

const emptyIcon = imageUrl("Folder.svg");

const Archives = ({ pageContext }) => {
  const category_meta = pageContext?.selectedCat?.data;
  const [data, setData] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [search, setSearch] = useState(false);
  const [loading, setLoading] = useState(false);
  const [paginationText, setPaginationText] = useState("");

  useEffect(() => {
    fetchData();
  }, [currentPage, search]);

  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await fetch(
        `${
          process.env.GATSBY_API_URL
        }archive/list?page=${currentPage}&q=${searchQuery}&category=${pageContext.category.description.replace(
          "&",
          "and",
        )}`,
        {
          headers: {
            "X-Api-Key": process.env.GATSBY_API_KEY,
          },
        },
      );
      const result = await response.json();
      setSearch(false);
      setLoading(false);
      setData(result.data);
      setTotalPages(result.pagination.totalPage);
      setPaginationText(result.pagination.paginationtext);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const handleSearch = (event) => {
    setSearchQuery(event.target.value);
    setCurrentPage(1);
  };

  const handleChange = (e, page) => {
    e.preventDefault();
    setCurrentPage(page);
  };

  let pages = _.range(currentPage - 5 < 0 ? 0 : currentPage - 5, totalPages > 10 ? currentPage + 5 : totalPages);

  return (
    <>
      <Header />
      <div class="filter-outer-container">
        <div class="aviation-archives-container w-lg-100 d-lg-flex flex-lg-wrap">
          <div class="container-fluid">
            <div class="row">
              <div class="col-md-12">
                <div className="aac-head">
                  <div class=" d-flex align-items-md-center justify-content-between" style={{ marginBottom: "10px" }}>
                    <h1 className="archives-heading">
                      {pageContext.category.description} Archives {loading ? "" : `(${paginationText})`}
                    </h1>

                    <div class="custom-search-box white-search-box position-relative">
                      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g opacity="0.4">
                          <path
                            d="M9.16667 15.8333C12.8486 15.8333 15.8333 12.8486 15.8333 9.16667C15.8333 5.48477 12.8486 2.5 9.16667 2.5C5.48477 2.5 2.5 5.48477 2.5 9.16667C2.5 12.8486 5.48477 15.8333 9.16667 15.8333Z"
                            stroke="black"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M17.5 17.5L13.875 13.875"
                            stroke="black"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </g>
                      </svg>
                      <input
                        type="text"
                        class="search-input"
                        placeholder="Search archived listings"
                        onChange={handleSearch}
                        onKeyDown={(k) => {
                          if (k.key === "Enter") {
                            setSearch(true);
                          }
                        }}
                      />
                    </div>
                  </div>
                  <div className="showing-result-text new-text-styles detail-auction-text-fix search-margin-fix">
                    <h2 style={{ fontSize: "1rem", marginBottom: "0px", fontWeight: "400" }}>
                      {" "}
                      {category_meta?.content_overview ? category_meta?.content_overview : ""}
                    </h2>
                  </div>
                </div>
                <div class="aac-body">
                  <div class="table-responsive mb-30">
                    <table class="new-product-list-table table table-bordered table-wrap">
                      <thead class="table-light">
                        <tr>
                          <th>Listing ID</th>
                          <th>Listing Title</th>
                          <th>Qty</th>
                          <th>Location</th>
                          <th>End Date</th>
                        </tr>
                      </thead>
                      <tbody>
                        {loading ? (
                          [1, 2, 3, 4, 5, 6, 7, 8, 9, 0, 0, 0].map((row) => (
                            <tr>
                              <td>
                                <Skeleton />
                              </td>
                              <td>
                                <Skeleton />
                              </td>
                              <td>
                                <Skeleton />
                              </td>
                              <td>
                                {" "}
                                <Skeleton />
                              </td>
                              <td>
                                {" "}
                                <Skeleton />
                              </td>
                            </tr>
                          ))
                        ) : data && data.length > 0 ? (
                          data.map((row) => (
                            <tr>
                              <td>
                                <a
                                  href={"javascript:void(0)"}
                                  onClick={() => navigate(`/listings/listing_detail.cfm/aucid/${row._id}`)}
                                >
                                  {row._id}
                                </a>
                              </td>
                              <td>
                                <div class="product-item d-flex">
                                  <a
                                    href={"javascript:void(0)"}
                                    onClick={() => navigate(`/listings/listing_detail.cfm/aucid/${row._id}`)}
                                  >
                                    <div class="pi-img">
                                      <img
                                        src={
                                          row?.primaryPicture
                                            ? row.primaryPicture?.toLowerCase()
                                            : "https://media.salvex.com/auction/p/1830079/183007825_698229_lp.jpg"
                                        }
                                        alt={row.title}
                                      />
                                    </div>
                                  </a>
                                  <p>
                                    {" "}
                                    <a
                                      href={"javascript:void(0)"}
                                      onClick={() => navigate(`/listings/listing_detail.cfm/aucid/${row._id}`)}
                                      className="archive-title-font"
                                    >
                                      {row.title}
                                    </a>
                                  </p>
                                </div>
                              </td>
                              <td>
                                {row.quantity} {row.unit}
                              </td>
                              <td>{row.country}</td>
                              <td>
                                {" "}
                                <DateFormat date={row.endDate} />
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colspan="11" class="td-empty-row">
                              <div class="dashboard-empty-block text-center">
                                <div class="deb-img-box">
                                  <img src={emptyIcon} alt="empty List" />
                                </div>
                                <h5>There are no records to display</h5>
                              </div>
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                  <div class="pagination-container d-flex align-items-center justify-content-between">
                    {totalPages > 1 && (
                      <div
                        class="pagination-btn prev-btn"
                        onClick={() => {
                          if (currentPage > 1) {
                            setCurrentPage(currentPage - 1);
                            window.scrollTo({ top: 0, behavior: "smooth" });
                          }
                        }}
                      >
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M11 17L6 12L11 7"
                            stroke="black"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M18 17L13 12L18 7"
                            stroke="black"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                        <span>Previous</span>
                      </div>
                    )}
                    <ul class="pagination">
                      {currentPage + 1 > 6 ? (
                        <li
                          onClick={(e) => {
                            handleChange(e, 1);
                          }}
                          className={"page-item"}
                        >
                          <a
                            className="page-link"
                            href={`javascript:void(0)`}
                            onClick={(e) => {
                              e.preventDefault();
                            }}
                          >
                            1
                          </a>
                        </li>
                      ) : (
                        ""
                      )}
                      {currentPage + 1 > 7 ? (
                        <li
                          onClick={(e) => {
                            handleChange(e, 2);
                          }}
                          className={"page-item"}
                        >
                          <a
                            className="page-link"
                            href={`javascript:void(0)`}
                            onClick={(e) => {
                              e.preventDefault();
                            }}
                          >
                            2
                          </a>
                        </li>
                      ) : (
                        ""
                      )}{" "}
                      {currentPage + 1 > 8 ? (
                        <li
                          onClick={(e) => {
                            handleChange(e, 3);
                          }}
                          className={"page-item"}
                        >
                          <a
                            className="page-link"
                            href={`javascript:void(0)`}
                            onClick={(e) => {
                              e.preventDefault();
                            }}
                          >
                            3
                          </a>
                        </li>
                      ) : (
                        ""
                      )}
                      {currentPage > 5 ? <li className={"page-item"}>...</li> : ""}
                      {pages.map(
                        (i) =>
                          i + 1 <= totalPages && (
                            <li
                              onClick={(e) => {
                                handleChange(e, i + 1);
                              }}
                              className={currentPage === i + 1 ? "page-item active" : "page-item"}
                            >
                              <a
                                className="page-link"
                                href={`javascript:void(0)`}
                                onClick={(e) => {
                                  e.preventDefault();
                                }}
                              >
                                {i + 1}
                              </a>
                            </li>
                          ),
                      )}
                      {currentPage < totalPages - 5 ? <li className={"page-item"}>...</li> : ""}
                      {currentPage < totalPages - 7 ? (
                        <li
                          onClick={(e) => {
                            handleChange(e, totalPages);
                          }}
                          className={"page-item"}
                        >
                          <a
                            className="page-link"
                            href={`javascript:void(0)`}
                            onClick={(e) => {
                              e.preventDefault();
                            }}
                          >
                            {totalPages - 2}
                          </a>
                        </li>
                      ) : (
                        ""
                      )}
                      {currentPage < totalPages - 6 ? (
                        <li
                          onClick={(e) => {
                            handleChange(e, totalPages - 1);
                          }}
                          className={"page-item"}
                        >
                          <a
                            className="page-link"
                            href={`javascript:void(0)`}
                            onClick={(e) => {
                              e.preventDefault();
                            }}
                          >
                            {totalPages - 1}
                          </a>
                        </li>
                      ) : (
                        ""
                      )}{" "}
                      {currentPage < totalPages - 5 ? (
                        <li
                          onClick={(e) => {
                            handleChange(e, totalPages);
                          }}
                          className={"page-item"}
                        >
                          <a
                            className="page-link"
                            href={`javascript:void(0)`}
                            onClick={(e) => {
                              e.preventDefault();
                            }}
                          >
                            {totalPages}
                          </a>
                        </li>
                      ) : (
                        ""
                      )}
                      {/* {currentPage - 2 > 0 && (
                        <li
                          class="page-item "
                          onClick={() => {
                            setCurrentPage(currentPage - 2);
                            window.scrollTo({ top: 0, behavior: "smooth" });
                          }}
                        >
                          <a class="page-link" href="#">
                            {currentPage - 2}
                          </a>
                        </li>
                      )}
                      {currentPage - 1 > 0 && (
                        <li
                          class="page-item "
                          onClick={() => {
                            setCurrentPage(currentPage - 1);
                            window.scrollTo({ top: 0, behavior: "smooth" });
                          }}
                        >
                          <a class="page-link" href="#">
                            {currentPage - 1}
                          </a>
                        </li>
                      )}
                      {totalPages > 1 && (
                        <li class="page-item active">
                          <a class="page-link" href="#">
                            {currentPage}
                          </a>
                        </li>
                      )}
                      {currentPage + 1 <= totalPages && (
                        <li
                          class="page-item "
                          onClick={() => {
                            setCurrentPage(currentPage + 1);
                            window.scrollTo({ top: 0, behavior: "smooth" });
                          }}
                        >
                          <a class="page-link" href="#">
                            {currentPage + 1}
                          </a>
                        </li>
                      )}
                      {currentPage + 2 <= totalPages && (
                        <li
                          class="page-item "
                          onClick={() => {
                            setCurrentPage(currentPage + 2);
                            window.scrollTo({ top: 0, behavior: "smooth" });
                          }}
                        >
                          <a class="page-link" href="#">
                            {currentPage + 2}
                          </a>
                        </li>
                      )}
                      {currentPage + 2 < totalPages - 3 ? (
                        <>
                          <li className={"page-item"}>
                            <a
                              href={`javascript:void(0)`}
                              onClick={(e) => {
                                e.preventDefault();
                              }}
                            >
                              ...
                            </a>
                          </li>
                          <li
                            onClick={(e) => {
                              setCurrentPage(totalPages - 3);
                            }}
                            className={"page-item"}
                          >
                            <a
                              className="page-link"
                              href={`javascript:void(0)`}
                              onClick={(e) => {
                                e.preventDefault();
                              }}
                            >
                              {totalPages - 3}
                            </a>
                          </li>{" "}
                          <li
                            onClick={(e) => {
                              setCurrentPage(totalPages - 2);
                            }}
                            className={"page-item"}
                          >
                            <a
                              className="page-link"
                              href={`javascript:void(0)`}
                              onClick={(e) => {
                                e.preventDefault();
                              }}
                            >
                              {totalPages - 2}
                            </a>
                          </li>{" "}
                          <li
                            onClick={(e) => {
                              setCurrentPage(totalPages - 1);
                            }}
                            className={"page-item"}
                          >
                            <a
                              className="page-link"
                              href={`javascript:void(0)`}
                              onClick={(e) => {
                                e.preventDefault();
                              }}
                            >
                              {totalPages - 1}
                            </a>
                          </li>
                          <li
                            onClick={(e) => {
                              setCurrentPage(totalPages);
                            }}
                            className={"page-item"}
                          >
                            <a
                              className="page-link"
                              href={`javascript:void(0)`}
                              onClick={(e) => {
                                e.preventDefault();
                              }}
                            >
                              {totalPages}
                            </a>
                          </li>
                        </>
                      ) : (
                        ""
                      )} */}
                    </ul>
                    {totalPages > 1 && (
                      <div
                        class="pagination-btn next-btn"
                        onClick={() => {
                          if (currentPage < totalPages) {
                            setCurrentPage(currentPage + 1);
                            window.scrollTo({ top: 0, behavior: "smooth" });
                          }
                        }}
                      >
                        <span>Next </span>
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M13 17L18 12L13 7"
                            stroke="black"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M6 17L11 12L6 7"
                            stroke="black"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                      </div>
                    )}
                  </div>
                  {category_meta && category_meta.content_full ? (
                    <p
                      style={{ marginTop: "40px" }}
                      dangerouslySetInnerHTML={{
                        __html: category_meta?.content_full.replace("#FFFFFF", "#0b0000"),
                      }}
                    ></p>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        <Footer />
      </div>
    </>
  );
};

export default Archives;
export const Head = ({ location, pageContext }) => (
  <SEO
    title={`${pageContext.category.description} Archives`}
    description={`${
      pageContext?.selectedCat?.data?.meta_description ? pageContext?.selectedCat?.data?.meta_description + " - " : ""
    } ${pageContext.category.description} Archives`}
    canonical={`https://www.salvex.com${location.pathname}`}
  />
);
